import { Form } from "antd";
import { FormProps } from "antd/lib";
import { ReactNode } from "react";

import cn from "@/utils/tailwind/cn";

type Props<T> = {
  children: ReactNode;
} & Omit<FormProps<T>, "children">;

const FormRoot = <T,>({ className, ...props }: Props<T>) => (
  <Form<T>
    className={cn("relative flex h-full w-full flex-col", className)}
    {...props}
  />
);

export default FormRoot;
